import {
    UPDATE_REPERTOIRE,
    GET_REPERTOIRE_REQUEST,
    GET_REPERTOIRE_SUCCESS,
    GET_REPERTOIRE_FAIL,
    GET_ALL_REPERTOIRES_REQUEST,
    GET_ALL_REPERTOIRES_SUCCESS,
    GET_ALL_REPERTOIRES_FAIL,
    GET_REPERTOIRE_TREE_REQUEST,
    GET_REPERTOIRE_TREE_SUCCESS,
    GET_REPERTOIRE_TREE_FAIL,
    GET_AUTHORIZED_REPERTOIRE_TREE_REQUEST,
    GET_AUTHORIZED_REPERTOIRE_TREE_SUCCESS,
    GET_AUTHORIZED_REPERTOIRE_TREE_FAIL,
    GET_ACCESSIBLE_REPERTOIRE_TREE_REQUEST,
    GET_ACCESSIBLE_REPERTOIRE_TREE_SUCCESS,
    GET_ACCESSIBLE_REPERTOIRE_TREE_FAIL,
    GET_REPERTOIRE_CONTEXT_REQUEST,
    GET_REPERTOIRE_CONTEXT_SUCCESS,
    GET_REPERTOIRE_CONTEXT_FAIL,
    GET_REPERTOIRE_BREADCRUMB_SUCCESS,
    GET_REPERTOIRE_BREADCRUMB_FAIL,
    GET_REPERTOIRES_BY_STATUS_REQUEST,
    GET_REPERTOIRES_BY_STATUS_SUCCESS,
    GET_REPERTOIRES_BY_STATUS_FAIL,
    CREATE_REPERTOIRE_REQUEST,
    CREATE_REPERTOIRE_SUCCESS,
    CREATE_REPERTOIRE_FAIL,
    UPDATE_REPERTOIRE_REQUEST,
    UPDATE_REPERTOIRE_SUCCESS,
    UPDATE_REPERTOIRE_FAIL,
    CHANGE_REPERTOIRE_STATUS_REQUEST,
    CHANGE_REPERTOIRE_STATUS_SUCCESS,
    CHANGE_REPERTOIRE_STATUS_FAIL,
    DELETE_REPERTOIRE_REQUEST,
    DELETE_REPERTOIRE_SUCCESS,
    DELETE_REPERTOIRE_FAIL,
    SET_REPERTOIRE_LOADING,
    CLEAR_REPERTOIRE_MESSAGE,
    CLEAR_REPERTOIRE_ERROR,
    SET_SELECTED_REPERTOIRE,
    SET_REPERTOIRE_EXPANDED_KEYS,
    TOGGLE_REPERTOIRE_EXPANDED_KEY
} from '../actions/repertoireActions';

const initialState = {
    repertoires: [],
    repertoireTree: [],
    authorizedRepertoireTree: [],
    accessibleRepertoireTree: [],
    currentRepertoire: null,
    currentContext: null,
    breadcrumb: [],
    selectedRepertoireId: null,
    expandedKeys: {},
    loading: false,
    treeLoading: false,
    contextLoading: false,
    message: '',
    error: null
};

function repertoireReducer(state = initialState, action) {
    switch (action.type) {
        case UPDATE_REPERTOIRE:
            return {
                ...state,
                currentRepertoire: action.repertoire
            };

        case SET_REPERTOIRE_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case SET_SELECTED_REPERTOIRE:
            return {
                ...state,
                selectedRepertoireId: action.payload
            };

        case SET_REPERTOIRE_EXPANDED_KEYS:
            return {
                ...state,
                expandedKeys: action.payload || {}
            };

        case TOGGLE_REPERTOIRE_EXPANDED_KEY:
            return {
                ...state,
                expandedKeys: {
                    ...state.expandedKeys,
                    [action.payload]: !state.expandedKeys[action.payload]
                }
            };

        case CLEAR_REPERTOIRE_MESSAGE:
            return {
                ...state,
                message: ''
            };

        case CLEAR_REPERTOIRE_ERROR:
            return {
                ...state,
                error: null
            };

        case GET_REPERTOIRE_REQUEST:
        case GET_ALL_REPERTOIRES_REQUEST:
        case GET_REPERTOIRE_TREE_REQUEST:
        case GET_AUTHORIZED_REPERTOIRE_TREE_REQUEST:
        case GET_REPERTOIRES_BY_STATUS_REQUEST:
        case CREATE_REPERTOIRE_REQUEST:
        case UPDATE_REPERTOIRE_REQUEST:
        case CHANGE_REPERTOIRE_STATUS_REQUEST:
        case DELETE_REPERTOIRE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_ACCESSIBLE_REPERTOIRE_TREE_REQUEST:
            return {
                ...state,
                treeLoading: true,
                error: null
            };

        case GET_REPERTOIRE_CONTEXT_REQUEST:
            return {
                ...state,
                contextLoading: true,
                error: null
            };

        case GET_REPERTOIRE_SUCCESS:
            return {
                ...state,
                currentRepertoire: action.payload,
                loading: false
            };

        case GET_ALL_REPERTOIRES_SUCCESS:
        case GET_REPERTOIRES_BY_STATUS_SUCCESS:
            return {
                ...state,
                repertoires: action.payload,
                loading: false,
                error: null
            };

        case GET_REPERTOIRE_TREE_SUCCESS:
            return {
                ...state,
                repertoireTree: action.payload,
                loading: false,
                error: null
            };

        case GET_AUTHORIZED_REPERTOIRE_TREE_SUCCESS:
            return {
                ...state,
                authorizedRepertoireTree: action.payload,
                loading: false,
                error: null
            };

        case GET_ACCESSIBLE_REPERTOIRE_TREE_SUCCESS:
            return {
                ...state,
                accessibleRepertoireTree: action.payload,
                treeLoading: false,
                error: null
            };

        case GET_REPERTOIRE_CONTEXT_SUCCESS:
            return {
                ...state,
                currentContext: action.payload,
                currentRepertoire: action.payload?.current || null,
                breadcrumb: action.payload?.breadcrumb || [],
                contextLoading: false,
                error: null
            };

        case GET_REPERTOIRE_BREADCRUMB_SUCCESS:
            return {
                ...state,
                breadcrumb: action.payload || [],
                error: null
            };

        case CREATE_REPERTOIRE_SUCCESS:
            return {
                ...state,
                loading: false,
                message: 'Repertoire cree avec succes'
            };

        case UPDATE_REPERTOIRE_SUCCESS:
            return {
                ...state,
                currentRepertoire: action.payload,
                loading: false,
                message: 'Repertoire mis a jour avec succes'
            };

        case CHANGE_REPERTOIRE_STATUS_SUCCESS:
            return {
                ...state,
                currentRepertoire: action.payload,
                loading: false,
                message: 'Statut mis a jour avec succes'
            };

        case DELETE_REPERTOIRE_SUCCESS:
            return {
                ...state,
                loading: false,
                message: 'Repertoire supprime avec succes'
            };

        case GET_REPERTOIRE_FAIL:
        case GET_ALL_REPERTOIRES_FAIL:
        case GET_REPERTOIRE_TREE_FAIL:
        case GET_AUTHORIZED_REPERTOIRE_TREE_FAIL:
        case GET_REPERTOIRES_BY_STATUS_FAIL:
        case CREATE_REPERTOIRE_FAIL:
        case UPDATE_REPERTOIRE_FAIL:
        case CHANGE_REPERTOIRE_STATUS_FAIL:
        case DELETE_REPERTOIRE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case GET_ACCESSIBLE_REPERTOIRE_TREE_FAIL:
            return {
                ...state,
                treeLoading: false,
                error: action.error
            };

        case GET_REPERTOIRE_CONTEXT_FAIL:
            return {
                ...state,
                contextLoading: false,
                error: action.error
            };

        case GET_REPERTOIRE_BREADCRUMB_FAIL:
            return {
                ...state,
                error: action.error
            };

        default:
            return state;
    }
}

export default repertoireReducer;
